import React from 'react';
import { isMobile } from 'react-device-detect';
import { StyledReactTooltip } from '../../../../globalStyled';
import { StyledKindIcon } from './styled';

const KIND = {
  bot: {
    label: 'Team managed by a bot until a new owner claims it',
    title: 'Bot',
  },
  human: {
    label: 'Managed by a player',
    title: 'Player',
  },
  freeAgent: {
    label: 'Free agent',
    title: 'Free agent',
  },
};

const IconGlyph = ({ kind }) => {
  if (kind === 'bot') {
    return (
      <svg viewBox="0 0 16 16" aria-hidden>
        <rect
          x="3.25"
          y="5.25"
          width="9.5"
          height="7.5"
          rx="1.6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
        />
        <path
          d="M8 5.2V3.4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
        <circle cx="8" cy="2.6" r="0.9" fill="currentColor" />
        <circle cx="6.2" cy="8.6" r="0.85" fill="currentColor" />
        <circle cx="9.8" cy="8.6" r="0.85" fill="currentColor" />
      </svg>
    );
  }
  if (kind === 'freeAgent') {
    return (
      <svg viewBox="0 0 16 16" aria-hidden>
        <circle
          cx="8"
          cy="8"
          r="5.4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeDasharray="2.2 1.8"
        />
        <circle cx="8" cy="6.1" r="1.55" fill="currentColor" />
        <path
          d="M5.2 11.4c.55-1.45 1.5-2.15 2.8-2.15s2.25.7 2.8 2.15"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 16 16" aria-hidden>
      <circle cx="8" cy="5.2" r="2.15" fill="currentColor" />
      <path
        d="M4.15 13.35c.4-2.5 1.85-3.7 3.85-3.7s3.45 1.2 3.85 3.7z"
        fill="currentColor"
      />
    </svg>
  );
};

const TeamOwnerIcon = ({ kind, tooltipId }) => {
  const meta = KIND[kind] || KIND.human;
  return (
    <>
      <StyledKindIcon
        $kind={kind}
        data-tip
        data-for={tooltipId}
        data-tip-disable={isMobile}
        aria-label={meta.title}
      >
        <IconGlyph kind={kind} />
      </StyledKindIcon>
      <StyledReactTooltip id={tooltipId} type="light" effect="solid" place="bottom">
        {meta.label}
      </StyledReactTooltip>
    </>
  );
};

export default React.memo(TeamOwnerIcon);
